module.exports = __webpack_public_path__ + "static/media/light-tiktok-icon.d68276c1.svg";